module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/Asset-registry-hero-desktop@2x-2d48668c84ccc40acddb30bc3cbf5cf3.svg";